
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import relativeTime from 'bits/relative_time'
import { hyphenatedCurrentLocale } from 'bits/current_locale'

/**
 * Displays the duration relative to given date/time.
 */
@Component
export default class RelativeTime extends Vue {
  /**
   * Display the duration from this date/time.
   */
  @Prop() datetime!: string | number | Date

  /**
   * The format to display the relative time in.
   */
  @Prop({ default: 'short' }) dateformat!: 'short' | 'long'

  get relativeTime(): string {
    return relativeTime(this.datetime, this.dateformat)
  }

  get actualTime(): string {
    const date = new Date(this.datetime)
    return date.toLocaleString(hyphenatedCurrentLocale)
  }
}
